import {del, get, post, put} from './capitalAxios';

const BASE = '/api/v1/tax-config';

export const findAllTaxConfigs = () => get(BASE);
export const createTaxConfig = (body) => post(BASE, body);
export const updateTaxConfig = (id, body) => put(`${BASE}/${id}`, body);
export const deleteTaxConfig = (id) => del(`${BASE}/${id}`);
